/**
 * Get the number of items per page
 *
 * For performance reason his will clamp the value to the smallest of either:
 * - the maximum number of items that can be displayed inside the block
 * - the "max N number of items" optimization introduced in PM-16368
 */
const getNbItemsPerPage = (itemsPerRow) => {
  const ROWS_TO_FETCH = 6;

  return Math.min(8, itemsPerRow * ROWS_TO_FETCH);
};

export default getNbItemsPerPage;
